module.exports = __webpack_public_path__ + "img/device-check.221c1fc0.png";